import cssAnimation from 'css-animation';
import getRequestAnimationFrame, { cancelRequestAnimationFrame } from './getRequestAnimationFrame';

const /** @type {?} */ reqAnimFrame = getRequestAnimationFrame();
/**
 * @param {?} node
 * @param {?} show
 * @param {?} done
 * @return {?}
 */
function animate(node: HTMLElement, show: boolean, done: Function) {
    let /** @type {?} */ height: number;
    let /** @type {?} */ requestAnimationFrameId: number;
    return cssAnimation(node, 'ant-motion-collapse', {
/**
 * @return {?}
 */
start() {
            if (!show) {
                node.style.height = `${node.offsetHeight}px`;
                node.style.opacity = '1';
            } else {
                height = node.offsetHeight;
                node.style.height = '0';
                node.style.opacity = '0';
            }
        },
/**
 * @return {?}
 */
active() {
            if (requestAnimationFrameId) {
                cancelRequestAnimationFrame(requestAnimationFrameId);
            }
            requestAnimationFrameId = reqAnimFrame(() => {
                node.style.height = `${show ? height : 0}px`;
                node.style.opacity = show ? '1' : '0';
            });
        },
/**
 * @return {?}
 */
end() {
            if (requestAnimationFrameId) {
                cancelRequestAnimationFrame(requestAnimationFrameId);
            }
            node.style.height = '';
            node.style.opacity = '';
            done();
        },
    });
}

const /** @type {?} */ animation = {
/**
 * @param {?} node
 * @param {?} done
 * @return {?}
 */
enter(node: HTMLElement, done: Function) {
        return animate(node, true, done);
    },
/**
 * @param {?} node
 * @param {?} done
 * @return {?}
 */
leave(node: HTMLElement, done: Function) {
        return animate(node, false, done);
    },
/**
 * @param {?} node
 * @param {?} done
 * @return {?}
 */
appear(node: HTMLElement, done: Function) {
        return animate(node, true, done);
    },
};

export default animation;
